/**
 * Sanitizes a string input by:
 * 1. Trimming leading/trailing whitespace only
 * 2. Removing HTML tags
 * 3. Escaping special characters
 * 4. Limiting length to 25 characters
 * 5. Preserving spaces within text
 */
export const sanitizeInput = (input: string, maxLength: number = 25): string => {
  if (!input) return '';
  
  // Trim only leading/trailing whitespace
  let sanitized = input.trim();
  
  // Remove HTML tags
  sanitized = sanitized.replace(/<[^>]*>/g, '');
  
  // Escape special characters
  sanitized = sanitized
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
  
  // Limit length
  return sanitized.slice(0, maxLength);
};

/**
 * Sanitizes a room code by:
 * 1. Converting to uppercase
 * 2. Removing any non-alphanumeric characters
 * 3. Limiting to 4 characters
 */
export const sanitizeRoomCode = (code: string): string => {
  if (!code) return '';
  return code.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 4);
}; 